import _ from '@lodash';
import * as Actions from '../../actions/fuse/index';

const initialState = {
    navigation: null,
    empresa: null,
};

const navigation = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_NAVIGATION:
            {
                return {
                    ...state
                };
            }
        case Actions.SET_NAVIGATION:
            {
                return {
                    navigation: action.navigation,
                    empresa: !_.isNull(action.navigation) ? Object.keys(action.navigation)[0] : null,
                };
            }
        case Actions.SET_EMPRESA:
            {
                return {
                    ...state,
                    empresa: action.empresa,
                };
            }
        case Actions.RESET_NAVIGATION:
            {
                return {
                    ...initialState
                };
            }
        default:
            {
                return state;
            }
    }
};

export default navigation;
